import { inject, Injectable, OnDestroy } from '@angular/core';
import { MaintenanceService } from '@campus/browser';
import {
  AUTH_SERVICE,
  AuthFacade,
  AuthServiceInterface,
  CampaignInterface,
  CampaignService,
  LinkedPersonService,
  RegistrationCredentials,
} from '@campus/public-portal';
import { merge, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RegisterPageContainerViewModel implements OnDestroy {
  private authService: AuthServiceInterface = inject(AUTH_SERVICE);
  private auth = inject(AuthFacade);
  private maintenanceService = inject(MaintenanceService);
  private campaignService = inject(CampaignService);
  private _registrationErrors = new Subject<string>();

  public registrationError$ = this.getRegistrationError$();
  public isMaintenanceMode$: Observable<boolean>;

  constructor() {
    this.isMaintenanceMode$ = this.maintenanceService.isMaintenanceMode();
  }

  public register(credentials: RegistrationCredentials) {
    const credentialsWithType = { ...credentials, userType: 'student' };
    this.auth.register(credentialsWithType);
  }

  public getCampaign(campaignKey: string): Observable<CampaignInterface> {
    return this.campaignService.getCampaign(campaignKey);
  }

  private getRegistrationError$(): Observable<string> {
    return merge(this._registrationErrors.asObservable(), this.auth.error$);
  }

  ngOnDestroy(): void {
    this.authService.clearError();
  }
}
